// extracted by mini-css-extract-plugin
module.exports = {"root":"PasswordResetForm_root__1Rxjm","password":"PasswordResetForm_password__1kR72"};